import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import GoogleChart from "../../../../../components/googleChart/googleChart";
import DateFilters from "../../views/DateFilters";
import { actionCreators } from "../../redux/sagas/marketing";
import SectionToggle from "../../../../../components/sectionToggle/sectionToggle";
import LearnMore from "../../../../../components/learnMore/learnMore";

const NumOfIntros = (props) => {
  const dispatch = useDispatch();
  const { moduleName, chartContentTitle, chartContent } = props;
  const { toggleView, updateFilters, updateData, fetchData } = actionCreators(moduleName);

  const {
    dataTable: { rows = [], cols = [] },
    initialRequest,
    options,
    listeners,
    isTable,
    isLoading,
    filters
  } = useSelector((state) => state[moduleName]);

  // switch between table and chart views
  const switchView = (view) => dispatch(toggleView({ moduleName, view, filters }));

  useEffect(() => {
    !initialRequest && dispatch(fetchData(props));
  }, []);
  let content = () => {
    return (
      <div id="module-date-filters" data-testid={moduleName}>
        <DateFilters
          moduleName={moduleName}
          actionCreators={{ updateFilters, updateData, fetchData }}
        />
        <div className="chart-root">
          <GoogleChart
            chartName="number_of_intros_sold_chart"
            isTableView={isTable}
            enableEventListeners
            height={400}
            chartType={isTable ? "Table" : "ColumnChart"}
            rows={rows}
            columns={cols}
            listeners={listeners}
            switchView={switchView}
            options={options}
            showAdditionTooltip={false}
          />
        </div>
      </div>
    );
  };
  return (
    <SectionToggle
      isLoading={isLoading}
      height={400}
      title={chartContentTitle}
      content={content()}
      learnMore={
        chartContent && <LearnMore content={chartContent} title={chartContentTitle} html />
      }
    />
  );
};

export default React.memo(NumOfIntros);
